export default "__VITE_ASSET__DqQBgFC9__"